"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ATTR_ASS_ORDER_ID = void 0;
exports.default = reducer;
exports.myAppointmentReducerState = exports.myAppointmentMapState = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _contractPropTypes = require("../components/Dashboardiii/propTypes/contractPropTypes");
var _myAppointmentDetailLoadAction = require("../actions/MyAppointment/myAppointmentDetailLoadAction");
var _myAppointmentGapLoadAction = require("../actions/MyAppointment/myAppointmentGapLoadAction");
var _myAppointmentGapSaveAction = require("../actions/MyAppointment/myAppointmentGapSaveAction");
var _myAppointmentWishSaveAction = require("../actions/MyAppointment/myAppointmentWishSaveAction");
var _myAppointmentTypes = require("../types/myAppointmentTypes");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ATTR_ASS_ORDER_ID = exports.ATTR_ASS_ORDER_ID = 'assOrderId';
var myAppointmentReducerState = exports.myAppointmentReducerState = {
  assOrderId: _propTypes.default.string.isRequired,
  data: (0, _propTypes.shape)(_contractPropTypes.contractProps),
  appointmentOrder: (0, _propTypes.shape)(_myAppointmentTypes.appointmentOrderPropType),
  appointmentWish: (0, _propTypes.shape)(_myAppointmentTypes.myAppointmentWish),
  appointmentGapList: _propTypes.default.array,
  cancelledAppointment: (0, _propTypes.shape)(_myAppointmentTypes.appointmentOrderPropType),
  week: _propTypes.default.object,
  isLoading: _propTypes.default.bool
};
var myAppointmentMapState = exports.myAppointmentMapState = {
  myAppointment: (0, _propTypes.shape)(myAppointmentReducerState).isRequired
};
// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _myAppointmentDetailLoadAction.SET_SELECTED_APPOINTMENT:
      {
        var appointmentSelectionAction = action;
        return _objectSpread(_objectSpread({}, state), {}, {
          assOrderId: appointmentSelectionAction.data.assOrderId,
          appointmentOrder: appointmentSelectionAction.data.innerData,
          isLoading: false
        });
      }
    case _myAppointmentGapLoadAction.LOAD_APPOINTMENT_GAPS:
      {
        var appointmentLoadGapsAction = action;
        return _objectSpread(_objectSpread({}, state), {}, {
          appointmentGapList: appointmentLoadGapsAction.data.innerData,
          week: appointmentLoadGapsAction.data.week,
          isLoading: false
        });
      }
    case _myAppointmentGapSaveAction.SAVE_APPOINTMENT:
      {
        var appointmentSaveAction = action;
        return _objectSpread(_objectSpread({}, state), {}, {
          appointmentOrder: appointmentSaveAction.data.innerData,
          cancelledAppointment: state.appointmentOrder,
          appointmentWish: null,
          isLoading: false
        });
      }
    case _myAppointmentWishSaveAction.SAVED_APPOINTMENT_WISH:
      {
        var _appointmentSaveAction = action;
        return _objectSpread(_objectSpread({}, state), {}, {
          appointmentWish: _appointmentSaveAction.data.innerData,
          cancelledAppointment: state.appointmentOrder,
          isLoading: false
        });
      }
    case _myAppointmentGapLoadAction.SET_APPOINTMENT_LOADING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }
    case _myAppointmentGapLoadAction.THROW_APPOINTMENT_ERROR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false
        });
      }
    default:
      return state;
  }
}